const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.821,27.529H5.281 c-0.782,0-1.416-0.634-1.416-1.416V5.681c0-0.782,0.634-1.416,1.416-1.416h21.54c0.782,0,1.416,0.634,1.416,1.416v20.432 C28.237,26.895,27.603,27.529,26.821,27.529z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.825,
    y: 9.828,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 0.84,
    height: 12.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.462,
    y: 9.828,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 0.839,
    height: 12.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.867,
    y: 8.212,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 2.414,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.867,
    y: 6.596,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 2.414,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.412,
    y: 24.457,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 3.274,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.412,
    y: 22.841,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 3.274,
    height: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.046,13.654 c-0.439-1.378-1.114-2.665-2.006-3.823c-1.469-1.91-3.025-2.826-3.187-2.919c-0.741-0.472-1.377-0.561-1.889-0.266 c-1.034,0.597-0.975,2.541-0.965,2.761l0.83-0.038c-0.024-0.537,0.08-1.732,0.551-2.003c0.279-0.161,0.717,0.049,1.035,0.252 l0.021,0.013c0.015,0.009,1.552,0.885,2.968,2.736c0.076,0.1,0.15,0.201,0.223,0.302h-5.527v0.86h6.091 c0.235,0.395,0.444,0.801,0.629,1.217h-6.72v0.861h7.061c0.136,0.39,0.251,0.789,0.346,1.196h-7.407v0.861h7.574 c0.063,0.405,0.108,0.818,0.132,1.238h-7.706v0.861h7.727c-0.003,0.42-0.024,0.847-0.064,1.28h-7.663v0.86h7.565 c-0.16,1.041-0.534,2.555-1.233,2.984c-0.147,0.09-0.391,0.19-0.804,0.014c-0.189-0.084-3.563-1.578-5.13-1.578 c-0.017,0-0.034,0-0.05,0.001l0.018,0.831c0.012,0,0.025,0,0.037,0c1.158,0,3.843,1.084,4.79,1.507l0.006,0.003 c0.256,0.109,0.507,0.163,0.749,0.163c0.289,0,0.565-0.078,0.818-0.233c0.636-0.39,1.119-1.265,1.434-2.599 c0.215-0.91,0.277-1.716,0.283-1.804C26.774,17.235,26.593,15.372,26.046,13.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.137,6.646 c-0.512-0.296-1.148-0.206-1.889,0.266c-0.162,0.092-1.718,1.009-3.187,2.919c-0.892,1.159-1.567,2.445-2.006,3.823 c-0.548,1.718-0.728,3.581-0.537,5.538c0.006,0.087,0.068,0.893,0.283,1.804c0.315,1.334,0.798,2.208,1.434,2.599 c0.253,0.155,0.528,0.233,0.818,0.233c0.242,0,0.494-0.054,0.749-0.163l0.006-0.003c0.947-0.423,3.632-1.507,4.79-1.507 c0.013,0,0.025,0,0.038,0l0.018-0.831c-0.016,0-0.033-0.001-0.05-0.001c-1.567,0-4.941,1.493-5.13,1.578 c-0.413,0.175-0.657,0.076-0.804-0.014c-0.699-0.429-1.073-1.942-1.233-2.984h7.565v-0.86H6.339 c-0.04-0.434-0.062-0.86-0.064-1.28h7.727v-0.861H6.296c0.024-0.42,0.068-0.833,0.131-1.238h7.574v-0.861H6.595 c0.095-0.407,0.209-0.806,0.346-1.196h7.061v-0.861h-6.72c0.185-0.416,0.394-0.822,0.629-1.217h6.091v-0.86H8.475 c0.073-0.101,0.147-0.202,0.223-0.302c1.415-1.851,2.952-2.727,2.968-2.736l0.021-0.013c0.318-0.204,0.756-0.413,1.035-0.252 c0.471,0.271,0.575,1.467,0.551,2.003l0.83,0.038C14.112,9.187,14.171,7.243,13.137,6.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M29.463,25.786c0,1.935-1.569,3.504-3.504,3.504s-3.504-1.569-3.504-3.504 c0-1.935,1.569-3.504,3.504-3.504S29.463,23.851,29.463,25.786z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "28.331,24.787 26.944,24.787  26.944,23.399 25.037,23.399 25.037,24.787 23.649,24.787 23.649,26.693 25.037,26.693 25.037,28.081 26.944,28.081  26.944,26.693 28.331,26.693  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiology);
export default __webpack_public_path__ + "static/media/radiology.f157876c010758b5d947f05392010215.svg";
export { ForwardRef as ReactComponent };